module.exports = __webpack_public_path__ + "img/borrow-return-qr-scan.48ea44d3.svg";